import { Chip as MuiChip } from "@mui/material"
import { makeStyles } from "@mui/styles"
import T from "prop-types"
import { createElement as h } from "react"

const useStyles = makeStyles(({ withPalette }) => ({
  root: ({ backgroundColor, color, shade }) => ({
    "&.MuiChip-root": {
      backgroundColor: backgroundColor || "#ececec",
      borderRadius: "12px",
      color: withPalette(color, shade),
      fontSize: "14px",
      fontWeight: "bold",
      height: "28px",
    },
  }),
}))

export const Chip = ({ backgroundColor, color = "#000000", label, shade, ...rest }) =>
  h(MuiChip, {
    classes: useStyles({ backgroundColor, color, shade }),
    label,
    ...rest,
  })

Chip.propTypes = {
  label: T.string.isRequired,
}
